import Inputmask from 'inputmask';

export const formatPhone = (input: any) => {
    input.classList.add('js-input-format-phone');
    Inputmask({
        mask: '+7 (999) 999-99-99',
        showMaskOnHover: false,
        placeholder: '_',
    }).mask(input);
};

export const formatContract = (input: any) => {
    input.classList.add('js-input-format-contract');
    Inputmask({
        mask: 'БК/99-999',
        showMaskOnHover: false,
        placeholder: '_',
    }).mask(input);
};

export const formatDate = (input: any) => {
    input.classList.add('js-input-format-date');
    Inputmask('datetime', {
        inputFormat: 'dd.mm.yyyy',
        showMaskOnHover: false,
        placeholder: '_',
    }).mask(input);
};

export const formatTime = (input: any) => {
    input.classList.add('js-input-format-time');
    Inputmask('datetime', {
        inputFormat: 'HH:MM',
        showMaskOnHover: false,
        placeholder: '_',
    }).mask(input);
};

export const formatCost = (input: any) => {
    input.classList.add('js-input-format-cost');
    Inputmask('numeric', {
        groupSeparator: ' ',
        digits: 0,
        digitsOptional: false,
        suffix: ' ₽',
        rightAlign: false,
        max: Number(input.getAttribute('data-max')),
        min: Number(input.getAttribute('data-min')),
    }).mask(input);
    if (input.getAttribute('data-min')) {
        input.addEventListener('blur', () => {
            input.dispatchEvent(new Event('input'));
        });
    }
};

export const formatPassport = (input: any) => {
    input.classList.add('js-input-format-passport');
    Inputmask('numeric', {
        mask: '9999 999999',
        showMaskOnHover: false,
        placeholder: '_',
        rightAlign: false,
    }).mask(input);
};

export const formatPassportCode = (input: any) => {
    input.classList.add('js-input-format-passport-code');
    Inputmask({
        mask: '999-999',
        showMaskOnHover: false,
        placeholder: '_',
    }).mask(input);
};

export const formatNumber = (input: any) => {
    input.classList.add('js-input-format-number');
    Inputmask('numeric', {
        rightAlign: false,
        showMaskOnHover: false,
        placeholder: '',
    }).mask(input);
};

export const formatSnils = (input: any) => {
    input.classList.add('js-input-format-snils');
    Inputmask({
        mask: '999-999-999 99',
        showMaskOnHover: false,
        placeholder: '_',
    }).mask(input);
};

document.addEventListener('DOMContentLoaded', () => {
    // const costs = document.querySelectorAll(
    //     '.js-input-format-cost, input[data-js-format="cost"]'
    // );
    // costs.forEach((input) => {
    //     formatCost(input);
    // });
    //
    // const dates = document.querySelectorAll(
    //     '.js-input-format-date, input[data-js-format="date"]'
    // );
    // dates.forEach((input) => {
    //     formatDate(input);
    // });
    //
    // const passports = document.querySelectorAll(
    //     '.js-input-format-passport, input[data-js-format="passport"]'
    // );
    // passports.forEach((input) => {
    //     formatPassport(input);
    // });
});
